import { Alert as o, alertClasses as e } from "@mui/material";
import { styled as l } from "./styled2.mjs";
const i = l(o)`
	width: ${({ theme: r }) => r.spacing(50)};
	overflow-wrap: break-word;

	&.${e.root} {
		&.${e.filledSuccess} {
			border-left-color: ${({ theme: r }) => r.palette.success.main};
		}

		&.${e.filledError} {
			border-left-color: ${({ theme: r }) => r.palette.error.main};
		}

		&.${e.filledWarning} {
			border-left-color: ${({ theme: r }) => r.palette.warning.main};
		}

		&.${e.filledInfo} {
			border-left-color: ${({ theme: r }) => r.palette.info.main};
		}
	}

	.${e.icon} {
		display: none;
	}
`;
export {
  i as Alert
};
//# sourceMappingURL=styles29.mjs.map
